export enum TemplateType {
    CONTAINER = "container",
    CONTENT = "content"
}